import { AbstractDTO } from '../abstract';
declare let _: any;

export class FormButton extends AbstractDTO {
    id: string;
    type: any;
	attributes: { btnClass: string; };
    text: string;
    func: any;
    disabledFunc: any;
    disabledClass: string;
    visible: boolean;

    constructor(attributes?: Object) {
        super(attributes);
        this.id = attributes['id'];
        this.type = attributes['type'] || 'button';
        this.attributes = attributes['attributes'] || { btnClass: 'btn-primary ' + this.id.replace(/[\w]([A-Z])/g, function(m) {
                return m[0] + "-" + m[1];
            }).toLowerCase() };
        this.text = attributes['text'] || '';
        this.func = attributes['func'];
        this.disabledFunc = attributes['disabledFunc'] || null;
        this.disabledClass = attributes['disabledClass'] || 'd-none';
        this.visible = !_.isUndefined(attributes['visible'])? attributes['visible']:  true;
    }

    get isVisible() {
        return this.visible;
    }

}
